<template>
  <div class="content" v-if="$auth.ready()">
    <div class="columns is-centered is-gapless" style="margin-top: 3rem;">
      <div class="column is-4">
        <div class="box">
          <h2 class="is-title is-bold has-text-centered has-text-primary">
            ChangeVU Free Trial Login
          </h2>
          <hr></hr>
          <div v-show="error" style="color:red; word-wrap:break-word;">{{ error }}</div>
          <form v-on:submit.prevent="login">
            <div class="field">
              <label class="label">Email</label>
              <p class="control has-icon">
                <input v-model="user.email" class="input" type="text" placeholder="name@example.com">
                <span class="icon is-small">
                  <i class="fa fa-envelope"></i>
                </span>
              </p>
            </div>
            <div class="field">
            <label class="label">Password</label>
              <p class="control has-icon">
                <input v-model="user.password" class="input" type="password" placeholder="Password">
                <span class="icon is-small">
                  <i class="fa fa-lock"></i>
                </span>
              </p>
            </div>

            <!-- <p class="control" style="margin-top: 1rem;">
              <label class="checkbox">
                <input type="checkbox" v-model="user.rememberMe">
                Remember me
              </label>
            </p> -->
            
            <p class="control has-text-centered" style="margin-top: 1rem;">
              <button type="submit" class="button is-primary">Login</button>
              <!-- <button class="button is-light">Cancel</button> -->
            </p> 
          </form>
          <p class="control has-text-centered" style="margin-top: 1rem;">
            <a href="#/forgotPassword">Forgot Password</a>
          </p>
          <!-- <p class="control has-text-centered" style="margin-top: 1rem;">
            New to ChangeVU? <a href="#/onBoard"> Start Free Trial</a>
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../../router'
import * as globalConstants from '../../globalConstants.js'

// import postData from '../../assets/data/data.json'
export default {
  data () {
    return {
      showForm: false,
      user: {
        email: '',
        password: '',
        rememberMe: false
      },
      error: null
    }
  },
  mounted () {
    if (this.$auth.redirect()) {
      console.log('Redirect from: ' + this.$auth.redirect().from.name)
    }
  },
  methods: {
    login () {
      if (this.user.email === '') {
        this.$noty.error('Please enter email address.')
      } else if (this.user.password === '') {
        this.$noty.error('Password can not be blank')
      } else {
        this.$auth.login({
          url: globalConstants.apiURL + '/auth/local',
          body: this.user,
          success: function (res) {
            axios.get(globalConstants.apiURL + '/auth/local')
            .then(response => {
              this.$cookie.set('token', res.data.token)
              this.$cookie.set('role', response.data.role)
              if (response.data.profilePicture) {
                this.$store.commit('setUserImageSrc', globalConstants.apiURL + '/' + response.data.profilePicture)
              } else {
                this.$store.commit('setUserImageSrc', globalConstants.apiURL + '/uploads/' + 'extra-large.jpg')
              }
              if (response.data.logoPath) {
                this.$store.commit('setClientLogoSrc', globalConstants.apiURL + '/' + response.data.logoPath)
              } else {
                this.$store.commit('setClientLogoSrc', globalConstants.apiURL + '/uploads/' + 'changeVULogo.png')
              }
              this.$store.commit('setCurrentUserName', response.data.firstName + ' ' + response.data.lastName)
              if (response.data.currentInitiative) {
                // set current initiative data
                this.$store.commit('setCurrentInitiativeName', response.data.currentInitiative.initiativeName)
                this.$store.commit('setCurrentInitiativeTeamName', response.data.currentInitiative.teamName)
                if (response.data.currentInitiative.teamLead) {
                  this.$store.commit('setCurrentInitiativeTeamLead', response.data.currentInitiative.teamLead.firstName + ' ' + response.data.currentInitiative.teamLead.lastName)
                }
                this.$store.commit('setCurrentInitiativeImplementationStage', response.data.currentInitiative.implementationStage)

                window.localStorage.setItem('Initiative', JSON.stringify({id: response.data.currentInitiative._id, name: response.data.currentInitiative.initiativeName}))
              }
              window.localStorage.setItem('user', JSON.stringify(response.data))

              // following code needs to optimized
              let user = JSON.parse(window.localStorage.getItem('user'))
              this.user = user
              let currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'))
              this.currentInitiative = currentInitiative
              let diagonactic
              if (currentInitiative) {
                for (var i = 0; i < user.diagonactics.length; i++) {
                  if (user.diagonactics[i].initiative === currentInitiative.id) {
                    diagonactic = user.diagonactics[i]
                    break
                  }
                }
              }
              if (diagonactic) {
                this.$store.commit('setIdentifySponsor', diagonactic.risks[0] ? diagonactic.risks[0] : '')
                this.$store.commit('setVisionClarity', diagonactic.risks[1] ? diagonactic.risks[1] : '')
                this.$store.commit('setSponsoringCoalition', diagonactic.risks[2] ? diagonactic.risks[2] : '')
                this.$store.commit('setSponsorCapability', diagonactic.risks[3] ? diagonactic.risks[3] : '')
                this.$store.commit('setGovernance', diagonactic.risks[4] ? diagonactic.risks[4] : '')
                this.$store.commit('setProgrammeManagement', diagonactic.risks[5] ? diagonactic.risks[5] : '')
                this.$store.commit('setBudgetingandResourcing', diagonactic.risks[6] ? diagonactic.risks[6] : '')
                this.$store.commit('setProgrammeDelivery', diagonactic.risks[7] ? diagonactic.risks[7] : '')
                this.$store.commit('setBusinessRequirements', diagonactic.risks[8] ? diagonactic.risks[8] : '')
                this.$store.commit('setOrganizationDesign', diagonactic.risks[9] ? diagonactic.risks[9] : '')
                this.$store.commit('setChangeReadiness', diagonactic.risks[10] ? diagonactic.risks[10] : '')
                this.$store.commit('setImplementationPlanning', diagonactic.risks[11] ? diagonactic.risks[11] : '')
                this.$store.commit('setChangeLeadership', diagonactic.risks[12] ? diagonactic.risks[12] : '')
                this.$store.commit('setStakeholderEngagement', diagonactic.risks[13] ? diagonactic.risks[13] : '')
                this.$store.commit('setImplementationCapability', diagonactic.risks[14] ? diagonactic.risks[14] : '')
                this.$store.commit('setSupportPeoplesJournery', diagonactic.risks[15] ? diagonactic.risks[15] : '')
              }

              if (response.data.role === 'superAdmin') {
                router.push({ path: '/admin' })
              } else {
                router.push({ path: '/home' })
              }
            })
            .catch(error => {
              console.log(error)
            })
          },
          data: this.user,
          error: function () {},
          rememberMe: this.user.rememberMe,
          fetchUser: false
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.is-title {
    text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Login.vue?04c65324